/** Thai strings for the monster contest (English source text -> Thai): Notebook → Contest, Hall of Fame. */
export const CONTEST: Record<string, string> = {
  Contest: 'ประกวด',
  'Monster Contest': 'ประกวดมอนสเตอร์',
  'Enter your best drawing, vote for your favourites, and the winner joins the game!': 'ส่งรูปที่วาดเก่งที่สุด โหวตตัวที่ชอบ แล้วผู้ชนะจะได้เข้ามาอยู่ในเกม!',
  'Opening the contest box…': 'กำลังเปิดกล่องประกวด…',
  'Opening the Hall of Fame…': 'กำลังเปิดหอเกียรติยศ…',
  'Sign in to the battle server to enter and vote.': 'เข้าสู่เซิร์ฟเวอร์ก่อน ถึงจะส่งผลงานและโหวตได้',
  'Round {round}': 'รอบ {round}',
  'voting closes {when}': 'ปิดโหวต{when}',
  '{n} vote left of {max}': 'เหลือ {n} โหวตจาก {max}',
  '{n} votes left of {max}': 'เหลือ {n} โหวตจาก {max}',
  'first vote: +{n} coins': 'โหวตครั้งแรกได้ +{n} เหรียญ',
  'See it big': 'ดูรูปใหญ่',
  'See {name} big': 'ดูรูป {name} แบบใหญ่',
  'Sorted by votes: the monster with the most votes at the end of the week wins.': 'เรียงตามคะแนนโหวต ตัวที่ได้โหวตมากที่สุดตอนสิ้นสัปดาห์จะชนะ',
  "Vote for a drawing you like to see everyone's votes. Tap a picture to see it big.": 'โหวตตัวที่ชอบแล้วจะเห็นคะแนนโหวตของทุกตัว กดที่รูปเพื่อดูรูปใหญ่ได้',

  // My entry
  'My Entry': 'ผลงานของฉัน',
  'Draw a monster in public mode to enter it. Classroom monsters are for practice only.': 'วาดมอนสเตอร์แบบสาธารณะก่อนถึงจะส่งได้ มอนสเตอร์ห้องเรียนใช้ฝึกซ้อมเท่านั้น',
  'Monster to enter': 'มอนสเตอร์ที่จะส่ง',
  'Pick one of your drawings. You can enter one monster each week.': 'เลือกรูปที่วาดไว้ 1 ตัว ส่งได้สัปดาห์ละ 1 ตัว',
  'Enter the contest': 'ส่งเข้าประกวด',
  'Enter {name}?': 'ส่ง {name} เข้าประกวดไหม?',
  'Everyone will see the drawing, its name and your online name after a grown-up checks it.': 'หลังผู้ใหญ่ตรวจแล้ว ทุกคนจะเห็นรูป ชื่อมอนสเตอร์ และชื่อออนไลน์ของเรา',
  Enter: 'ส่งเลย',
  '{name} is in the contest!': '{name} เข้าประกวดแล้ว!',
  '{name} was sent! A grown-up will check it soon.': 'ส่ง {name} แล้ว! เดี๋ยวผู้ใหญ่จะตรวจให้',
  Withdraw: 'ถอนผลงาน',
  'Withdraw and try another': 'ถอนแล้วส่งตัวอื่น',
  'Withdraw your entry?': 'ถอนผลงานไหม?',
  "{name} leaves this week's contest, and any votes for it are lost.": '{name} จะออกจากการประกวดสัปดาห์นี้ และโหวตที่ได้จะหายไป',
  'BEING CHECKED': 'กำลังตรวจ',
  'IN THE CONTEST': 'กำลังประกวด',
  'NOT ACCEPTED': 'ไม่ผ่าน',
  CHAMPION: 'แชมป์',
  'A grown-up checks every entry before other players can see it.': 'ผู้ใหญ่จะตรวจทุกผลงานก่อนให้คนอื่นเห็น',
  'Everyone can vote for it until the round ends.': 'ทุกคนโหวตให้ได้จนกว่าจะปิดรอบ',
  'This one could not go in. Withdraw it and enter another drawing.': 'ตัวนี้ส่งไม่ได้ ถอนออกแล้วส่งรูปอื่นแทนนะ',
  'It won! It lives in the Hall of Fame now.': 'ชนะแล้ว! ตอนนี้อยู่ในหอเกียรติยศ',

  // Voting
  'Vote for Your Favourites': 'โหวตตัวที่ชอบ',
  'Votes stay secret until the round ends, so pick the drawings you really like.': 'คะแนนจะเป็นความลับจนปิดรอบ เลือกรูปที่ชอบจริงๆ นะ',
  'No monsters in this round yet. Be the first to enter!': 'รอบนี้ยังไม่มีมอนสเตอร์ ส่งเป็นคนแรกเลย!',
  'by {name}': 'โดย {name}',
  'No other monsters in this round yet. Tell your friends!': 'รอบนี้ยังไม่มีมอนสเตอร์ของคนอื่น ชวนเพื่อนมาส่งกัน!',
  'MY VOTE': 'โหวตแล้ว',
  Vote: 'โหวต',
  'Voted ✓': 'โหวตแล้ว ✓',
  'Take the vote back': 'ยกเลิกโหวต',
  'No votes left this week': 'สัปดาห์นี้โหวตครบแล้ว',
  'Vote for {name}': 'โหวตให้ {name}',
  'Vote counted! +{n} coins for your first vote this week.': 'นับโหวตแล้ว! ได้ +{n} เหรียญจากโหวตแรกของสัปดาห์',
  'Vote counted!': 'นับโหวตแล้ว!',
  Report: 'รายงาน',
  'Tell a grown-up something is not OK': 'บอกผู้ใหญ่ว่ามีอะไรไม่เหมาะสม',
  'Report this monster?': 'รายงานมอนสเตอร์ตัวนี้ไหม?',
  'The grown-ups who check the contest will look at it again.': 'ผู้ใหญ่ที่ดูแลการประกวดจะตรวจอีกครั้ง',
  'Thanks for telling us. A grown-up will take a look.': 'ขอบคุณที่บอกนะ เดี๋ยวผู้ใหญ่จะไปดู',

  // Hall of Fame
  'Hall of Fame': 'หอเกียรติยศ',
  'Every week the monster with the most votes joins the game. Anyone can fight it.': 'ทุกสัปดาห์ มอนสเตอร์ที่ได้โหวตมากที่สุดจะได้เข้ามาอยู่ในเกม ทุกคนสู้กับมันได้',
  "The first champion appears here when this week's round ends.": 'แชมป์คนแรกจะมาอยู่ที่นี่เมื่อปิดรอบสัปดาห์นี้',
  'Battle server offline — the Hall of Fame is unavailable.': 'เซิร์ฟเวอร์ปิดอยู่ ยังเปิดหอเกียรติยศไม่ได้',
  '{n} vote': '{n} โหวต',
  '{n} votes': '{n} โหวต',
  '{name} won the contest! You got the Champion stamp.': '{name} ชนะการประกวด! ได้ตราประทับแชมป์แล้ว',
  '{monster} won the monster contest!': '{monster} ชนะการประกวดมอนสเตอร์!',
  'Everyone voted, and now it lives in the Hall of Fame (round {round}).': 'ทุกคนโหวตให้ ตอนนี้มันอยู่ในหอเกียรติยศแล้ว (รอบ {round})',
  'Contest winners join here. ': 'ผู้ชนะการประกวดจะมาอยู่ที่นี่ ',
  'Open the contest': 'ไปหน้าประกวด',

  // Champion stamp (not for sale)
  'Contest Champion Stamp': 'ตราประทับแชมป์ประกวด',
  'Only for artists whose monster won a weekly contest.': 'มีเฉพาะคนที่วาดมอนสเตอร์ชนะการประกวดประจำสัปดาห์',
  '♛ CHAMPION ♛': '♛ แชมป์ ♛',

  // Server messages (backend/internal/contest), capitalised by the page
  'Only public-mode monsters can enter the contest.': 'ส่งประกวดได้เฉพาะมอนสเตอร์แบบสาธารณะ',
  "You already have a monster in this week's contest.": 'สัปดาห์นี้ส่งมอนสเตอร์ไปแล้ว 1 ตัว',
  'No such contest entry.': 'ไม่พบผลงานนี้',
  'That is not your entry.': 'นี่ไม่ใช่ผลงานของเรา',
  'This entry is not open for voting.': 'ผลงานนี้ยังโหวตไม่ได้',
  'You cannot vote for or report your own monster.': 'โหวตหรือรายงานมอนสเตอร์ของตัวเองไม่ได้',
  'You have used all 3 votes this week.': 'สัปดาห์นี้ใช้ครบ 3 โหวตแล้ว',
  'You already voted for this monster.': 'โหวตตัวนี้ไปแล้ว',
  'You have not voted for this monster.': 'ยังไม่ได้โหวตตัวนี้',
  'You already reported this monster.': 'รายงานตัวนี้ไปแล้ว',
};
